import { OperacionesInternacionalesStep } from "@/components/form-steps/OperacionesInternacionalesStep";
import { registerStep } from "./stepsRegistry";
import type { StepDefinition } from "./types";
import { InternationalInfoSchema } from "@/schemas/multistep/internacional-info.schema";

const definition: StepDefinition = {
  id: "operacionesInternacionales",
  title: "Operaciones internacionales",
  schema: InternationalInfoSchema,
  Component: OperacionesInternacionalesStep,
  isApplicable: () => true,
};

registerStep(definition);